import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

interface Config {
  enabled: boolean
}

export const useBusinessCentralCustomer = (businessCentralNumber: string, {
  enabled
}: Config) => {
  return useQuery({
    enabled,
    queryKey: ["businessCentralDetails", businessCentralNumber],
    queryFn: async () => window.CoreApi.BusinessCentral.GetCustomer(businessCentralNumber).then(r => r.data),
    retry: false
  });
};

export const useMutateBusinessCentralCustomerLink = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: window.CoreApi.Company.SetBusinessCentralNumber,
    onSuccess: () => {
      queryClient.invalidateQueries(["businessCentralDetails"]);
    }
  });
};